import { validContentSlug } from './seo.js';
import {
  ANALYTICS_EVENTS,
  analyticsLanguage,
  analyticsMethod
} from './analytics-events.js';

// Stable product IDs from the current catalogue, not translated title matching.
// New/unknown API products keep their own title and benefits without a guessed category.
const audiences = { 1: 'complete', 2: 'nutrition', 3: 'training', 5: 'home' };
export const programAudience = (id) => audiences[id] || '';
export function selectablePrograms(items) {
  if (!Array.isArray(items)) return [];
  return items.filter((item) => item && validContentSlug(item.slug));
}

const events = new Set(Object.keys(ANALYTICS_EVENTS));
const currencies = new Set(['USD', 'EUR', 'TRY']);
/** Allow only catalogue IDs/numeric commerce data. Never titles or profile data. */
export function funnelPayload(event, locale, data = {}) {
  if (!events.has(event) || event === 'purchase') return null;
  const result = { event, language: analyticsLanguage(locale) };
  const method = analyticsMethod(data.method);
  if (method) result.method = method;
  if (event === 'generate_lead') result.lead_source = 'contact';
  if (data.itemId !== undefined && data.itemId !== null) {
    const itemId = String(data.itemId);
    if (!/^[A-Za-z0-9_-]{1,80}$/.test(itemId)) return null;
    const item = { item_id: itemId, quantity: 1 };
    if ([1, 3, 6, 12].includes(Number(data.duration))) {
      item.item_variant = String(data.duration);
    }
    result.ecommerce = { items: [item] };
    if (
      currencies.has(
        String(data.currency || '')
          .trim()
          .toUpperCase()
      ) &&
      Number.isFinite(data.value) &&
      data.value >= 0
    ) {
      result.ecommerce.currency = data.currency.trim().toUpperCase();
      result.ecommerce.value = data.value;
      item.price = data.value;
    }
  }
  return result;
}
/** Optional analytics must never interrupt navigation or payment. */
export function dispatchFunnelEvent(target, consent, payload, options = {}) {
  const result = { plausible: false, google: false };
  if (!payload || !target) return result;
  try {
    if (options.plausible !== false)
      result.plausible = target.__idmanifyPlausible?.send(payload) === true;
  } catch {
    /* Optional collector errors cannot break navigation or payment. */
  }
  if (consent === true && options.google !== false) {
    try {
      target.dataLayer = target.dataLayer || [];
      target.dataLayer.push({
        ecommerce: null,
        method: null,
        lead_source: null
      });
      target.dataLayer.push(payload);
      result.google = true;
    } catch {
      /* Optional Google collector may be blocked. */
    }
  }
  return result;
}
export function pushFunnelEvent(target, consent, payload, options) {
  const result = dispatchFunnelEvent(target, consent, payload, options);
  return result.google || result.plausible;
}
